import { on } from '@ngrx/store';
import { FormState } from '../../state/form.state';
import {
    disableMeasurementEquipmentTable,
    updateMeasurementEquipmentColumnData,
    updateMeasurementEquipmentRowVisibility,
    updateMeasurementEquipmentSubmitSatus,
    updateMeasurementEquipmentsVisibility,
} from '../../actions/measurement-equipments.actions';
import { isDefined } from '@evorait/pace-core';

export function updateRowVisibilityReducer(
    state: Readonly<FormState>,
    props: { rowId: string; visibility: boolean },
): Readonly<FormState> {
    return {
        ...state,
        measuringEquipments: isDefined(state.measuringEquipments)
            ? {
                  ...state.measuringEquipments,
                  rows: state.measuringEquipments.rows.map((row) => {
                      const visibility = row.rowId === props.rowId ? props.visibility : row.visibility;

                      const upDatedColumn =
                          !props.visibility && row.rowId === props.rowId
                              ? row.columns.map((column) => ({
                                    ...column,
                                    value: '',
                                }))
                              : row.columns;
                      return {
                          ...row,
                          visibility,
                          columns: upDatedColumn,
                      };
                  }),
              }
            : undefined,
    };
}

export function disableTableReducer(
    state: Readonly<FormState>,
    props: { rowId: string; noToolsUsed?: boolean },
): Readonly<FormState> {
    return {
        ...state,
        measuringEquipments: isDefined(state.measuringEquipments)
            ? {
                  ...state.measuringEquipments,
                  rows: state.measuringEquipments.rows.map((row) => {
                      const visibility = row.rowId !== props.rowId ? false : row.visibility;

                      const clearedColumns = row.columns.map((column) => ({
                          ...column,
                          value: '',
                      }));

                      return {
                          ...row,
                          visibility,
                          columns: clearedColumns,
                      };
                  }),
                  noMeasurementToolsUsed: props.noToolsUsed ?? false,
              }
            : undefined,
    };
}

export function updateSubmitSatusReducer(
    state: Readonly<FormState>,
    props: {
        submitStatus: boolean;
    },
): Readonly<FormState> {
    return {
        ...state,
        measuringEquipments: isDefined(state.measuringEquipments)
            ? {
                  ...state.measuringEquipments,
                  canSubmitForm: props.submitStatus,
              }
            : undefined,
    };
}

export function updateColumnDataReducer(
    state: Readonly<FormState>,
    props: { columnId: string; rowId: string; value: string },
): Readonly<FormState> {
    if (!isDefined(state.measuringEquipments)) {
        return state;
    }
    return {
        ...state,
        measuringEquipments: {
            ...state.measuringEquipments,
            rows: state.measuringEquipments.rows.map((row) => {
                if (row.rowId === props.rowId) {
                    const updatedColumns = row.columns.map((column) =>
                        column.columnId === props.columnId ? { ...column, value: props.value } : column,
                    );
                    return {
                        ...row,
                        columns: updatedColumns,
                    };
                }

                return row;
            }),
        },
    };
}

export function updateMeasuringEquipmentsVisibilityReducer(
    state: Readonly<FormState>,
    props: { visibility: boolean },
): Readonly<FormState> {
    return {
        ...state,
        measuringEquipments: isDefined(state.measuringEquipments)
            ? {
                  ...state.measuringEquipments,
                  visibility: props.visibility,
              }
            : undefined,
    };
}

export const measuringEquipmentsReducer = [
    on<FormState, Array<typeof updateMeasurementEquipmentRowVisibility>>(
        updateMeasurementEquipmentRowVisibility,
        updateRowVisibilityReducer,
    ),
    on<FormState, Array<typeof updateMeasurementEquipmentsVisibility>>(
        updateMeasurementEquipmentsVisibility,
        updateMeasuringEquipmentsVisibilityReducer,
    ),
    on<FormState, Array<typeof disableMeasurementEquipmentTable>>(
        disableMeasurementEquipmentTable,
        disableTableReducer,
    ),
    on<FormState, Array<typeof updateMeasurementEquipmentColumnData>>(
        updateMeasurementEquipmentColumnData,
        updateColumnDataReducer,
    ),
    on<FormState, Array<typeof updateMeasurementEquipmentSubmitSatus>>(
        updateMeasurementEquipmentSubmitSatus,
        updateSubmitSatusReducer,
    ),
];
